import type { TranslateService } from '@ngx-translate/core';
import type { QrLabelText } from '@nebalkon-workspace/niimbot-printer';
import { formatOwnerLastNameForLabel } from './staff-qr-label-caption.util';

export type StaffQrLabelEntityKind = 'client' | 'box' | 'item' | 'cell';

const STAFF_QR_LABEL_TYPE_I18N_KEYS: Record<StaffQrLabelEntityKind, string> = {
  client: 'admin.qrLabelTypes.client',
  box: 'admin.qrLabelTypes.box',
  item: 'admin.qrLabelTypes.item',
  cell: 'admin.qrLabelTypes.cell',
};

export function buildStaffQrLabelText(
  translate: Pick<TranslateService, 'instant'>,
  kind: StaffQrLabelEntityKind,
  caption?: string,
): QrLabelText {
  const typeLabel = translate.instant(STAFF_QR_LABEL_TYPE_I18N_KEYS[kind]);
  const trimmed = caption?.trim();
  if (!trimmed) {
    return { typeLabel };
  }

  const formattedCaption =
    kind === 'cell'
      ? trimmed
      : (formatOwnerLastNameForLabel(trimmed) ?? trimmed);

  return {
    typeLabel,
    caption: formattedCaption,
  };
}
